import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import {
  MatchesAlbumFolderDetails,
  MatchesAlbumFolderChildrenDetails,
} from '../fragments/album-folder';
import { MatchesAlbumDetails } from '../fragments/album';
import { AlbumRootAlbumFolderBaseDetails } from '../../../../../../../graphql/fragments/album';
import { WebGalleryAlbumCustomPrintFields } from '../../../../../../web-gallery/graphql/fragments/album';

export const HierarchyItemForMatches = gql`
  query HierarchyItemForMatches(
    $id: RecordID!
    $exclude_albums_with_memberships: Boolean = false
  ) {
    hierarchyItem(id: $id) {
      ... on HierarchyAlbumFolderItem {
        id
        album_folder {
          id
          is_owner
          ...MatchesAlbumFolderDetails
          ...MatchesAlbumFolderChildrenDetails
          root {
            ...MatchesAlbumFolderDetails
          }
        }
      }
      ... on HierarchyAlbumItem {
        id
        album {
          id
          is_owner
          ...MatchesAlbumDetails
          ...AlbumRootAlbumFolderBaseDetails
          ...WebGalleryAlbumCustomPrintFields
          is_video_album
        }
      }
    }
  }
  ${MatchesAlbumDetails}
  ${AlbumRootAlbumFolderBaseDetails}
  ${WebGalleryAlbumCustomPrintFields}
  ${MatchesAlbumFolderDetails}
  ${MatchesAlbumFolderChildrenDetails}
`;

const getHierarchyItemForMatchesOptions = {
  options: ({ albumMembershipGroupId }) => ({
    variables: {
      id: albumMembershipGroupId,
    },
    fetchPolicy: 'cache-first',
  }),
  skip: ({ albumMembershipGroupId }) => !albumMembershipGroupId,
};

export const getHierarchyItemForMatches = graphql(
  HierarchyItemForMatches,
  getHierarchyItemForMatchesOptions,
);
